import React from 'react';
import { CheckCircle } from 'lucide-react';
import '../../styles/ServicesPage/servicessection.css';

const services = [
  {
    title: "Cloud & Infrastructure Consulting",
    image: require('../../assets/services/cloud.webp'),
    points: [
      "Cloud Architecture & Migration (AWS, Azure, GCP)",
      "Infrastructure as Code (Terraform, Pulumi, AWS CDK)",
      "Hybrid Cloud & Multi-Cloud Strategies",
      "Network Security & VPN Setup",
      "Serverless Architecture (Lambda, Azure Functions)"
    ]
  },
  {
    title: "AI, Data & Analytics",
    image: require('../../assets/services/AI.png'),
    points: [
      "Data Engineering & Big Data (Apache Spark, Airflow, EMR)",
      "Machine Learning Ops (MLflow, Vertex AI, SageMaker)",
      "Business Intelligence (Power BI, Tableau, Looker)",
      "AI Chatbots & Automation (NLP, GenAI integrations)",
      "Data Governance & Privacy Compliance (GDPR-ready)"
    ]
  },
  {
    title: "Application Development & Integration",
    image: require('../../assets/services//Mobile.png'),
    points: [
      "Web & Mobile App Development (React, Angular, Flutter)",
      "Low-Code Platforms (Mendix, OutSystems)",
      "Backend APIs (Node.js, Python, Java Spring Boot)",
      "Enterprise Application Integration (SAP, Oracle, Dynamics 365)",
      "Microservices & Event-Driven Architectures (Kafka, RabbitMQ)"
    ]
  },
  {
    title: "Cybersecurity & Compliance",
    image: require('../../assets/services/cyber.png'),
    points: [
      "Vulnerability Assessment & Pen Testing",
      "SOC Implementation",
      "Identity & Access Management (IAM)",
      "ISO 27001, GDPR, NIST Compliance Audits",
      "Security Awareness Training & Strategy"
    ]
  },
  {
    title: "DevOps & Site Reliability Engineering (SRE)",
    image: require('../../assets/services/devops.png'),
    points: [
      "CI/CD Pipeline Design (GitLab, Jenkins, Azure DevOps)",
      "Containerization & Orchestration (Docker, Kubernetes, OpenShift)",
      "Monitoring & Observability (Prometheus, Grafana, ELK, Splunk)",
      "Site Reliability Practices & Error Budgeting",
      "Security Automation (DevSecOps)"
    ]
  },
  {
    title: "IT Staffing & Talent Acquisition",
    image: require('../../assets/services/staf.jpg'),
    points: [
      "Permanent, Contract, and Freelance Staffing",
      "Tech Hiring (Developers, Architects, Engineers, Analysts)",
      "Remote & Nearshore Team Setup",
      "Recruitment Process Outsourcing (RPO)",
      "Executive Search for CTOs, CIOs, Engineering Heads"
    ]
  },
  {
    title: "Project Delivery & Managed Services",
    image: require('../../assets/services/project1.jpeg'),
    points: [
      "Agile, Scrum, and SAFe Project Management",
      "Dedicated Development Teams",
      "End-to-End IT Project Execution",
      "SLA-Based Managed Support (24x7 or On-Demand)",
      "IT Helpdesk and End User Support"
    ]
  }
];

function Services() {
  return (
    <section className="services-alternate-layout">
      {/* Intro Text */}
      <h4 className="services-subtitle">OUR SUITE OF SERVICES</h4>
      {/* <h2 className="services-title">Tailored IT & Consulting Expertise</h2> */}

      <div style={{ maxWidth: '1000px', margin: '0 auto', textAlign: 'center', marginBottom: '80px',  marginTop: '30px' }}>
        <h3 style={{ fontSize: '1.1rem', color: '#1f2937', marginBottom: '10px' }}>
          End-to-End IT Consulting & Recruitment Solutions Across Europe
        </h3>
        <p style={{ fontSize: '1rem', color: '#4b5563', lineHeight: '1.7' }}>
          At VSK Global Infotech, we specialize in delivering high-impact IT solutions and talent across the Netherlands,
          Poland, and all of Europe. Our services are crafted for startups, SMEs, and large enterprises looking to scale,
          optimize, or digitally transform.
        </p>
      </div>

      {/* Service Sections */}
      {services.map((service, index) => (
        <div className={`service-row ${index % 2 !== 0 ? 'reverse' : ''}`} key={index}>
          <div className="service-image">
            <img src={service.image} alt={service.title} />
          </div>
          <div className="service-content">
            <h3>{service.title}</h3>
            <ul>
              {service.points.map((point, idx) => (
                <li key={idx}>
                  <CheckCircle className="bullet-icon" size={18} />
                  {point}
                </li>
              ))}
            </ul>
          </div>
        </div>
      ))}
    </section>
  );
}

export default Services;
